import { colorToRgba } from '@wix/panda-js-utils';
export const getSiteFontSize = (style, referenceName) => 
// @ts-expect-error
style.siteTextPresets[referenceName] ? style.siteTextPresets[referenceName].size : null;
export const getSettingsFontSize = (style, settingsKey) => style.styleParams.fonts[settingsKey] ? `${style.styleParams.fonts[settingsKey].size}px` : null;
export const getFontSize = (style, defaultSiteFont, settingsKey) => getSettingsFontSize(style, settingsKey) || getSiteFontSize(style, defaultSiteFont);
export const getSettingsColor = (style, settingsKey, forceOpacity) => {
    const { colors } = style.styleParams;
    const colorValue = colors[settingsKey] ? colors[settingsKey].value : null;
    if (!colorValue) {
        return null;
    }
    return colorToRgba(colorValue, forceOpacity);
};
export const getSiteColor = (style, referenceName, forceOpacity) => {
    const colorMap = getSiteColorMap(style);
    return colorToRgba(colorMap[referenceName], forceOpacity);
};
export const getColorStyle = (style, ruleName, defaultSiteColor, settingsKey, forceOpacity) => {
    const color = (settingsKey && getSettingsColor(style, settingsKey, forceOpacity)) ||
        getSiteColor(style, defaultSiteColor, forceOpacity);
    return color ? { [ruleName]: color } : {};
};
const getSiteColorMap = (style) => {
    const map = {};
    style.siteColors.forEach(colorInfo => {
        map[colorInfo.reference] = colorInfo.value;
    });
    return map;
};
//# sourceMappingURL=style.js.map